import { WS_DAYS, WS_ONE_DAY } from '@pages/WorkSchedule/constants/filters';
import { WS_MODE_ADDITION } from '@pages/WorkSchedule/constants/modes';

import { createTimeIntervals } from '@pages/WorkSchedule/utils/createTimeIntervals';
import type { NWorkSchedule } from '@pages/WorkSchedule/WorkSchedule.types';

export const resetFilters: NWorkSchedule.ResetAdditionFilters = ({
  filters,
  mode = WS_MODE_ADDITION,
  setStartTime,
  setEndTime,
}) => {
  filters.current = {
    period: {
      primaryPeriod: WS_DAYS,
      detailedPeriod: WS_ONE_DAY,
    },
  };

  if (mode === WS_MODE_ADDITION) {
    if (setStartTime) {
      setStartTime({
        label: '10:00',
        value: createTimeIntervals().indexOf('10:00'),
      });
    }

    if (setEndTime) {
      setEndTime({
        label: '22:00',
        value: createTimeIntervals().indexOf('22:00'),
      });
    }
  }
};
